import React from 'react'
import { Container, Button, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

//const testData = require('./TestData.js');

class ImportLogFiles extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            clientAccountNumber: 0,
            clientName: '',
            clientId: 0,
            date: null,
            readSuccess: false,
            uploadSuccess: false,
            saveSuccess: false,
            accounts: [],
            securities: []
        };

    }

    componentDidMount = () => {
        this.props.log('ImportLogFiles.js/componentDidMount');
    }

    getClientName = (accountNumber) => {
        this.props.log('ImportLogFiles.js/getClientName (accountNumber)', accountNumber);
        if (accountNumber === '' || parseInt(accountNumber) === 0 || isNaN(parseInt(accountNumber))) return '';
        const arr = this.props.clients.filter(client => parseInt(client.customerNumber) === parseInt(accountNumber))
        if (arr[0] != null) return arr[0];
    }

    displayDate = (date) => {
        this.props.log('ImportLogFiles.js/displayDate (date)', date);
        let d = new Date(date);
        return (d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).substr(2, 2)
    }

    transformSecurities = (securities) => {
        this.props.log('ImportLogFiles.js/transformSecurities (securities)', securities);
        return securities.map(security => {
            const arr = security.match(/^([\S]+)\s([\S]+)\s([\S]+)\s-\s(.*)$/);
            if (arr.length > 0) {
                return [arr[1], arr[2], arr[3], arr[4]]
            } else {
                return []
            }
        });
    }

    handleUpload = (e, schema) => {
        this.props.log('ImportLogFiles.js/handleUpload (e,schema) ', e, schema);
        e.preventDefault();
        var files = e.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = (r) => {
            var securities = [];
            var accounts = [];
            var custodian = '';
            var accountNumbers = [];
            var isSecurity = false;
            var isAccount = false;
            var result = r.target.result.split("\r\n");
            result.forEach(line => {
                if (isSecurity && line !== '' && line !== "\n") {
                    securities.push(line);
                }
                if (isAccount && line !== '' && line !== "\n") {
                    accountNumbers.push(line);
                }
                if (line.substr(0, 14) === 'New Securities') isSecurity = true;
                if (line === '' || line === "\n") {
                    isSecurity = false;
                    isAccount = false;
                    if (custodian !== '' && accountNumbers.length > 0) {
                        accountNumbers.forEach(accountNumber => {
                            accounts.push([custodian, accountNumber])
                        })
                        custodian = '';
                        accountNumbers = [];
                    }
                }
                if (line.substr(0, 30) === 'The following are new accounts') {
                    isAccount = true;
                    let regexp = line.match(/for\s(.*):/i);
                    if (regexp[1] != null) custodian = regexp[1];
                }
            })
            this.setState({
                accounts: accounts,
                securities: this.transformSecurities(securities)
            });
        };
        if (typeof (f) === 'object') {
            let name = f.name.match(/\s([0-9]{4})\s/);
            let date = f.name.match(/\s([0-9]{6})-Log_/);
            if (name != null && name.length > 0 && name[1] != null) {
                this.setState({
                    readSuccess: true,
                    clientAccountNumber: parseInt(name[1]),
                    clientName: this.getClientName(name[1]).client,
                    clientId: this.getClientName(name[1]).id,
                    date: new Date('20' + date[1].substr(4, 2), parseInt(date[1].substr(0, 2)) - 1, parseInt(date[1].substr(2, 2)))
                }, () => reader.readAsText(f));
            } else {
                this.setState({
                    readSuccess: true
                }, () => reader.readAsText(f));
            }
        }
    }

    handleSave = () => {
        this.props.log('ImportLogFiles.js/handleSave');
        const json_request = JSON.stringify({
            clientId: this.state.clientId,
            date: this.state.date,
            securities: this.state.securities,
            accounts: this.state.accounts,
            reconciliations: []
        });
        fetch('/api/clientReports/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        readSuccess: false,
                        uploadSuccess: true,
                        saveSuccess: true,
                        accounts: [],
                        securities: [],
                        clientAccountNumber: 0,
                        clientName: '',
                        clientId: 0,
                        date: null
                    },() => this.props.addToast('Log files imported successfully.', 5, 'success')) :
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: false,
                    },() => this.props.addToast('Unable to import log files.', 5, 'danger'))
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    render = () => {
        this.props.info('ImportLogFiles.js/render');
        return (
            <>
                <Container>
                    {/* {this.state.uploadSuccess ?
                        <Row><Col md={12}> {(this.state.saveSuccess ?
                            <Alert color="success">Upload successful.</Alert> :
                            <Alert color="danger">Upload unsuccessful.</Alert>)}
                        </Col></Row>
                        : <></>} */}
                    <Row className='text-left'>
                        <Col md={12}>
                            <Row className="p-2">
                                <Col md={6} className="text-left">
                                    <Input type="file" name={"file_"} id="file" accept='.txt' onChange={e => this.handleUpload(e)} />
                                </Col>
                                <Col md={6}>
                                    {this.state.clientName !== '' ? this.state.clientName : ''}
                                    {this.state.clientAccountNumber !== 0 ? ' (' + this.state.clientAccountNumber + ')' : ''}
                                    {this.state.date != null ? <div>{this.displayDate(this.state.date)}</div> : <></>}
                                </Col>
                            </Row>
                            {this.state.accounts.length > 0 ?
                                <Row className="p-2">
                                    <Col md={12}>
                                        <h4>Accounts</h4>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Custodian</th>
                                                    <th>Account Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.accounts.map((account, accountIndex) => (
                                                    <tr key={accountIndex}>
                                                        <td>{account[0]}</td>
                                                        <td>{account[1]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row> : <></>}
                            {this.state.securities.length > 0 ?
                                <Row className="p-2">
                                    <Col md={12}>
                                        <h4>Securities</h4>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Symbol A</th>
                                                    <th>Symbol B</th>
                                                    <th>Security</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.securities.map((security, securityIndex) => (
                                                    <tr key={securityIndex}>
                                                        <td>{security[0]}</td>
                                                        <td>{security[1]}</td>
                                                        <td>{security[2]}</td>
                                                        <td>{security[3]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row> : <></>}
                            {this.state.securities.length === 0 && this.state.accounts.length === 0 && this.state.readSuccess ?
                                <Row className="p-2">
                                    <Col md={12}>
                                        <h4>No Accounts or Securities Found</h4>
                                    </Col>
                                </Row>
                                : <></>}
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Button color="success"
                                        disabled={/*(this.state.securities.length === 0 && this.state.accounts.length === 0) ||*/ !this.state.readSuccess}
                                        onClick={this.handleSave}
                                        title="Upload"
                                    >Upload</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default ImportLogFiles;